"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SocialCreateViewContainer = void 0;
exports.mapDispatchToProps = mapDispatchToProps;
exports.mapStateToProps = mapStateToProps;
var _reactRedux = require("react-redux");
var _authentication = require("../../actions/authentication");
var socialActions = _interopRequireWildcard(require("../../actions/social"));
var _view = require("../../actions/view");
var _selectors = require("./selectors");
var _SocialCreateViewContainer = require("./SocialCreateViewContainer");
var _social2 = require("../../selectors/social");
var _source = require("../../selectors/source");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function mapStateToProps(state) {
  return {
    disabled: (0, _selectors.disabledSelector)(state),
    hasError: (0, _selectors.hasErrorSelector)(state),
    error: (0, _selectors.errorSelector)(state),
    phone: (0, _social2.phoneSelector)(state),
    email: (0, _social2.emailSelector)(state),
    source: (0, _source.sourceSelector)(state)
  };
}
function mapDispatchToProps(dispatch) {
  return {
    changeEmail(email) {
      dispatch(socialActions.changeEmail(email));
    },
    changePhone(phone) {
      dispatch(socialActions.changePhone(phone));
    },
    create() {
      dispatch(socialActions.create());
    },
    reset() {
      dispatch((0, _authentication.reset)());
    },
    changeView(view) {
      dispatch((0, _view.changeView)(view));
    }
  };
}
const SocialCreateViewContainer = exports.SocialCreateViewContainer = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_SocialCreateViewContainer.SocialCreateViewContainer);